import { createFileRoute, Outlet } from "@tanstack/react-router";
import { StepFlowLayout } from "~/components/layouts/StepFlowLayout";

// @deprecated Standalone upload page — superseded by the UploadSessionsDialog
// opened from ChargerCard / the dashboard. No longer linked anywhere; safe to
// remove once we're sure no bookmarks/old links point here.
export const Route = createFileRoute("/(authenticated)/upload-laadsessies")({
  component: UploadLaadsessiesLayout,
});

function UploadLaadsessiesLayout() {
  return (
    <StepFlowLayout currentStep={1} totalSteps={1}>
      <Outlet />
    </StepFlowLayout>
  );
}
